import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomerApi from './customerApi';
import { Customer } from './customerType';
import HorizontalMenu from '../components/common/horizontalMenu';
import Breadcrumbs from '../components/common/breadcrumbs';
import { Alert } from '../components/ui/alert';
import { Button } from '../components/ui/button';
import { Trash } from 'lucide-react';
import { formatAddress } from '../lib/global_function';

const DeleteCustomerPage: React.FC = () => {
  const breadcrumbs = [
    { label: 'Customer', path: '/main/customer' },
    { label: 'Delete', path: '/main/customer/delete' },
  ];

  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location as { state: { customer: Customer } };
  const customer = state?.customer;

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  const handleDelete = async () => {
    try {
      if (customer?.customer_id) {
        await CustomerApi.delete(customer.customer_id);
        setMessage('Customer deleted successfully');
      }
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      } else {
        setErrorMessage('An unknown error occurred.');
      }
    }
  };

  return (
    <>
      <HorizontalMenu />
      <div className="container-safe py-6">
        <Breadcrumbs items={breadcrumbs} />

        <div className="mt-6">
          <h2 className="text-2xl font-semibold text-foreground mb-6">Delete Customer</h2>



          {message ? (
            <div>
              <Alert variant="success">
                {message}
              </Alert>

              <div className="flex gap-4">
                <Button
                  type="button"
                  onClick={() => navigate('/main/customer')}
                  size="medium" variant="default"
                >
                  Back to Customers
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <Alert variant="warning">
                If you delete the customer, all projects, estimates and itemized estimates linked to the customer will be deleted as well.
              </Alert>

              {errorMessage && (
                <Alert variant="error" >
                  {errorMessage}
                </Alert>
              )}

              <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <h4 className="text-lg font-semibold text-foreground mb-3">Customer Information</h4>
                <p className="mb-2">
                  <strong>Name:</strong> {customer?.first_name} {customer?.last_name}
                </p>
                <p className="mb-2">
                  <strong>Address:</strong> {formatAddress(customer?.address_1, customer?.address_2, customer?.city, customer?.state, customer?.zip)}
                </p>
                <p className="mb-2">
                  <strong>Email:</strong> {customer?.email}
                </p>
                <p className="mb-2">
                  <strong>Phone:</strong> {customer?.phone}
                </p>
              </div>

              <Button onClick={handleDelete} size="medium" variant="default" >
                <Trash size={20} />
                Delete Customer
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DeleteCustomerPage;